import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "tos",
        path: "/tos",
        component: () => import("./components/TosContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "tos-en",
                path: "en",
                component: () => import("./components/documents/standard/TosEn.vue"),
                meta: { guest: true },
            },
            {
                name: "tos-it",
                path: "it",
                component: () => import("./components/documents/standard/TosIt.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "r2u-tos",
        path: "/r2u-tos",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "tos-it",
                path: "it",
                component: () => import("./components/ExternalIframe.vue"),
                meta: { guest: true },
                props: { lang: "it", path: "tos" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "abruzzo-tos",
        path: "/abruzzo-tos",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "tos-it",
                path: "it",
                component: () => import("./components/ExternalIframe.vue"),
                meta: { guest: true },
                props: { lang: "it", path: "tos" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "tosFerrero",
        path: "/hco-tos",
        component: () => import("./components/TosContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "hco-tos-sr",
                path: "sr",
                component: () => import("./components/documents/hco/HCOTosSr.vue"),
                meta: { guest: true },
            },
            {
                name: "hco-tos-es",
                path: "es",
                component: () => import("./components/documents/hco/HCOTosEs.vue"),
                meta: { guest: true },
            },
            {
                name: "hco-tos-it",
                path: "it",
                component: () => import("./components/documents/hco/HCOTosIt.vue"),
                meta: { guest: true },
            },
            {
                name: "hco-tos-en",
                path: "en",
                redirect: "sr",
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "tosNiab",
        path: "/niab-tos",
        component: () => import("./components/TosContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "niab-tos-en",
                path: "en",
                component: () => import("./components/documents/niab/NIABTosEn.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "tosColdiretti",
        path: "/coldiretti-tos",
        component: () => import("./components/TosContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "coldiretti-tos-it",
                path: "it",
                component: () => import("./components/documents/coldiretti/ColdirettiPortalTosIt.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "privacy-policy",
        path: "/niab-privacy-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "niab-privacy-en",
                path: "en",
                component: () => import("./components/documents/niab/NiabPrivacy.vue"),
                meta: { guest: true },
                props: { lang: "en" },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "niab-cookie-policy",
        path: "/niab-cookie-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "niab-cookie-policy-en",
                path: "en",
                component: () => import("./components/documents/niab/NiabCookiePolicy.vue"),
                meta: { guest: true },
                props: { lang: "en", path: "cookie-policy" },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "niab-contacts",
        path: "/niab-contacts",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "niab-contacts-en",
                path: "en",
                component: () => import("./components/documents/niab/NiabContactAndCredit.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "cookie-policy",
        path: "/cookie-policy",
        component: () => import("./components/TosContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "cookie-en",
                path: "en",
                component: () => import("./components/documents/standard/CookieEn.vue"),
                meta: { guest: true },
            },
            {
                name: "cookie-it",
                path: "it",
                component: () => import("./components/documents/standard/CookieIt.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "abruzzo-cookie-policy",
        path: "/abruzzo-cookie-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "abruzzo-cookie-policy-it",
                path: "it",
                component: () => import("./components/ExternalIframe.vue"),
                meta: { guest: true },
                props: { lang: "it", path: "cookie-policy" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "coldiretti-cookie-policy",
        path: "/coldiretti-cookie-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "coldiretti-cookie-policy-it",
                path: "it",
                component: () => import("./components/documents/coldiretti/ColdirettiPortalCookiesIt.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "privacy-policy",
        path: "/privacy-policy",
        component: () => import("./components/TosContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "privacy-en",
                path: "en",
                component: () => import("./components/documents/standard/PrivacyEn.vue"),
                meta: { guest: true },
            },
            {
                name: "privacy-it",
                path: "it",
                component: () => import("./components/documents/standard/PrivacyIt.vue"),
                meta: { guest: true },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "privacy-policy",
        path: "/hco-privacy-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "hco-privacy-en",
                path: "en",
                component: () => import("./components/documents/hco/HcoPrivacy.vue"),
                meta: { guest: true },
                props: { lang: "en" },
            },
            {
                name: "hco-privacy-it",
                path: "it",
                component: () => import("./components/documents/hco/HcoPrivacy.vue"),
                meta: { guest: true },
                props: { lang: "it" },
            },
            {
                name: "hco-privacy-es",
                path: "es",
                component: () => import("./components/documents/hco/HcoPrivacy.vue"),
                meta: { guest: true },
                props: { lang: "es" },
            },
            {
                path: "*",
                redirect: "en",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "abruzzo-privacy-policy",
        path: "/abruzzo-privacy-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "abruzzo-privacy-policy-it",
                path: "it",
                component: () => import("./components/ExternalIframe.vue"),
                meta: { guest: true },
                props: { lang: "it", path: "privacy-policy" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "bioesperia-privacy-policy",
        path: "/bioesperia-privacy-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "bioesperia-privacy-policy-it",
                path: "it",
                component: () => import("./components/ExternalIframe.vue"),
                meta: { guest: true },
                props: { lang: "it", path: "privacy-policy" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "coldiretti-demo-privacy-policy",
        path: "/coldiretti-demo-privacy-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "privacy-it",
                path: "it",
                component: () => import("./components/documents/coldiretti/ColdirettiDemoPrivacyIt.vue"),
                meta: { guest: true },
                props: { lang: "it" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
    {
        name: "coldiretti-privacy-policy",
        path: "/coldiretti-privacy-policy",
        component: () => import("./components/ExternalContainer.vue"),
        meta: { guest: true },
        children: [
            {
                name: "privacy-it",
                path: "it",
                component: () => import("./components/documents/coldiretti/ColdirettiPortalPrivacyIt.vue"),
                meta: { guest: true },
                props: { lang: "it" },
            },
            {
                path: "*",
                redirect: "it",
                meta: { guest: true },
            },
        ],
    },
];

export default routes;
